import { render } from "./atmComponent.vue?vue&type=template&id=ea859afa"
import script from "./atmComponent.vue?vue&type=script&lang=js"
export * from "./atmComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__